import styles from "./VesselsCount.module.scss";

export const VesselsCount = ({mmsiCount}: { mmsiCount: number | undefined }) => {
  if (typeof mmsiCount !== 'number') return null;
  if (mmsiCount === 0) return <span>0</span>;
  return <span className={styles.mmsiCount}>{mmsiCount}</span>;
};
